<template>
    <div>
        <BreadCrumb :data="breadCrumb" />   

        <b-card no-body class="formGroup">
            <b-tabs pills card>
                <b-tab :title="$t('dealer.wizzard.stepName1')"  @click="pageSettings(false, 'Dealer')">
                    <b-card-text>
                        <Form ref="InformationForm" :loading="loading" :data="companyData" :forms="InformationForm" />
                    </b-card-text>
                </b-tab>
                
                <b-tab :title="$t('dealer.wizzard.stepName2')"  @click="pageSettings(true, 'CompanyAddresses')">
                    <b-card-text>
                        <Addresses ref="Address" :modalType="pageSettings" :modalEvent="openModal" :data="addresses"/>
                    </b-card-text>
                </b-tab>

                <b-tab :title="$t('dealer.wizzard.stepName3')" @click="pageSettings(true, 'CompanyUser')"> 
                    <b-card-text >
                         <Users ref="Users" :modalType="pageSettings" :modalEvent="openModal"  :data="users"/>
                    </b-card-text>
                </b-tab>
            </b-tabs>
             <template v-slot:footer class="footer">
                <b-button variant="success" v-if="newButton" @click="openModal(true, 'add' )">{{$t('general.add')}}</b-button>
                <b-button variant="primary" @click="saveData" v-if="currentForm=='Dealer'">{{$t('general.save')}}</b-button>
            </template>
        </b-card>
         <!-- Modals -->
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import GeneralForm from './components/GeneralForm'
    import Users from './components/Users'
    import Addresses from './components/Addresses'
    import Modals from './modals'
    import i18n from '@/plugins/i18n';
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'


      let breadCrumb = [
        { label: i18n.t('pages.dealer.name'), url: "/Dealer" },
        { label: i18n.t('pages.dealer.edit'),  },
    ]
    export default {
        name: "DealerEdit",
        created: function(){
             this.$store.dispatch('companyDetail', this.$route.params.id)
             this.$store.dispatch('companyaddresses_get',{parent_id: this.$route.params.id})
             this.$store.dispatch('companyuser_get', {parent_id: this.$route.params.id})
        },
        data: function(){
            return {
                breadCrumb,
                InformationForm: Forms.InformationForm, 
                newButton: false,
                modalOpen: false,
                modalProps: {},
                currentForm:"Dealer",
                modalName: "",
            }
        },
        components:{ BreadCrumb, Form, Users, Modals, Addresses },
        computed: {
            loading(){
                return this.$store.getters.getDealerLoading
            },
            message(){
                return this.$store.getters.getCompanyStatus
            },
            companyData(){
                this.breadCrumb = [
                    { label: "Bayiler", url: "/Dealer/List" },
                    { label: this.$store.getters.getCompany.name, url: "/Dealer/"+this.$route.params.id+"/edit"},
                    { label: i18n.t('pages.customer.edit'), url: "/Dealer/"+this.$route.params.id+"/edit" }
                ]
                return this.$store.getters.getCompany
            },
            addresses(){
                return this.$store.getters.getCompanyAddresses
            },
            users(){
                return this.$store.getters.getCompanyUsers
            }
            
        },
        methods:{
            pageSettings: function(state, form){
                this.newButton = state
                this.currentForm = form
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                this.modalProps = props
                this.modalName = modal
            },
            saveData: function(){
                switch(this.currentForm){
                    case "Dealer":
                        this.$refs.InformationForm.$refs.Form.validate().then(async success =>{
                            if(success){
                                let data =  prepareRequestData(this.InformationForm, this.$refs.InformationForm.formData)
                                data.id = this.$route.params.id
                                await this.$store.dispatch('dealer_edit', data)
                                await this.$store.dispatch('companyDetail', this.$route.params.id)

                            }else{
                                return false
                            }
                        })
                        
                        break;
                }
            }
        }
        
    }
</script>

<style lang="css" scoped> 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Dealer/Edit.vue